export const environment = {
  production: true,
  apiUrl: window.location.origin + '/api',
  siteUrl: 'https://www.ergoshop.ro/'
};
